<template>
    <!-- <AdminLayout> -->
        <section class="flex items-start">
            <div class="w-full">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between mb-5">
                            <p class="font-semibold text-xl text-neutral-800">WFH Request</p>
                            <div class="flex items-center space-x-4" v-if="userType === 'admin'">                              
                                <div class="ml-auto">
                                    <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                                    <select class="border rounded-lg px-2 py-2 text-sm " v-model="slectedLocation" @change="getWFHSummary">
                                        <option value="">Location</option>
                                        <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div v-if="isLoading">
                                <div class="grid grid-cols-7 bg-[#ECF6FF] divide-x-[1px] divide-white rounded-md animate-pulse">
                                    <div class="px-3 py-2 font-semibold col-span-2">
                                        <span class="w-full block rounded h-5 bg-neutral-300"></span>
                                    </div>
                                    <div class="px-3 py-2 font-semibold" v-for="index in 5" :key="index">
                                        <span class="w-full block rounded h-5 bg-neutral-300"></span>
                                    </div>
                                </div>
                                <div class="grid grid-cols-7 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="index in 4" :key="index">
                                    <div class="px-2 py-2 col-span-2">
                                        <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                    </div>
                                    <div class="px-2 py-2" v-for="index in 5" :key="index">
                                        <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="grid grid-cols-7 bg-[#ECF6FF] divide-x divide-[#eaeaea]">
                                    <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2">Employee Name</div>
                                    <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Employee ID</div>
                                    <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Designation</div>
                                    <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">WFH Request Date</div> 
                                    <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Current Status</div> 
                                    <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal justify-center">Action</div>
                                </div>
                                <div v-if="recordList.length > 0" class="overflow-x-auto">
                                    <div v-for="(wfhData, index) in recordList" :key="index" class="grid grid-cols-7 bg-white divide-x divide-y divide-[#eaeaea]">
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-2 border-t border-[#eaeaea]">
                                            {{ wfhData.employee.fname }} {{ wfhData.employee.lname }}
                                        </div>
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                            {{ wfhData.employee.empid }}
                                        </div>                                      
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                            {{ wfhData.employee.designation }}
                                        </div>
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                            {{ formatDate(wfhData.startDate) }} - {{ formatDate(wfhData.endDate) }}
                                        </div>
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                            {{ wfhData.status }}
                                        </div>
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                            <a href="#" class="inline-flex items-center justify-center bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal" @click="openPopup(wfhData.id, wfhData.status, wfhData.reason)">Take Action</a>
                                        </div>
                                    </div>
                                    <div class="flex pt-5 justify-end">
                                        <MultiPageComponent :page="pageData?.page" :totalPages="pageData?.totalPages"
                                        @page-change="handlePageChange" />
                                    </div>
                                </div>
                                <div v-else class="text-center py-5 text-gray-500">
                                    No records found.
                                </div>
                            </div>
                        </div>                      
                    </div>
                </div>
            </div>
            <!-- <RightSideBar /> -->
        </section>
        <div v-if="isPopupOpen" class="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 pt-4 px-2">
            <div class="max-w-2xl w-full bg-white mx-auto rounded-lg px-3 pt-3">
                <div class="bg-blue-400 py-3 relative rounded-t-lg">
                    <h3 class="text-center text-xl font-semibold text-white capitalize">Change WFH Status</h3>
                    <button @click="closePopup" class="absolute top-3 right-3 rounded-full bg-white w-7 h-7 flex items-center justify-center text-blue-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16">
                            <path fill="currentColor" d="M7.293 8L3.146 3.854a.5.5 0 1 1 .708-.708L8 7.293l4.146-4.147a.5.5 0 0 1 .708.708L8.707 8l4.147 4.146a.5.5 0 0 1-.708.708L8 8.707l-4.146 4.147a.5.5 0 0 1-.708-.708z"/>
                        </svg>
                    </button>
                </div>
                <div class="py-4 space-y-3">
                    <div>
                        <span>*Note By Employee</span>
                        <p class="w-full border border-gray-300 rounded-md px-3 py-2 text-xs">{{ wfhreason }}</p>          
                    </div>

                    <div>
                        <span>Change Status</span>
                        <select v-model="wfhStatus" class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm">
                            <option value="pending" disabled>Pending</option>
                            <option value="approved" >Approved</option>
                            <option value="reject" >Reject</option>
                        </select>                           
                    </div>

                    <div class="grid grid-cols-2 gap-1 pt-5">                      
                        <button 
                            @click="closePopup()" 
                            class="font-xl text-white font-semibold px-6 py-2 rounded-lg bg-gray-400 border border-gray-400"
                        >
                            Close
                        </button>
                        <button 
                            @click="saveWFHStatus()" 
                            class="font-xl text-white font-semibold px-6 py-2 rounded-lg bg-blue-400 border border-blue-400"
                        >
                            Save
                        </button>
                    </div>

                </div>
            </div>
        </div>
    <!-- </AdminLayout> -->
</template>

<script>
// import AdminLayout from '../AdminDashboard/AdminLayout.vue';
// import RightSideBar from '../../components/RightSideBar.vue';
import MultiPageComponent from "../../components/Widgets/MultiPageComponent.vue";
import { createLocal } from 'the-storages';
import axios from "axios";
import { BASE_URL } from "../../config";
import { createToast } from 'mosha-vue-toastify';
const mirror = createLocal();
const storage = mirror._prx;
import moment from "moment";

export default {
    name: 'AttendanceAdjustment',
    components: {
        // AdminLayout,
        // RightSideBar,
        MultiPageComponent,
    },
    
    data() {
        return {
            storage: storage,      
            filterMonth: new Date(),
            recordList: [],
            wfhStatus: '',
            wfhid: '',
            wfhreason: '',
            isPopupOpen: false,
            currentPage: 1,
            pageData: {},
            isLoading: false,
            branchList: [],  
            slectedLocation: '',    
            userType: '',
            globalDateFormat: '',  
        };
    },

    mounted() {     
        if (this.storage.userType === 'Super Admin') {               
            this.slectedLocation = ''; // Set to an empty string or a default value
            this.userType = 'admin';
        } else {
            this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
            this.userType = 'not-admin';
            console.log('branch', this.slectedLocation);
        }
        this.currentPage = this.$route.query.page ? this.$route.query.page : 1;  
        this.getWFHSummary();
        this.globalDateFormat = localStorage.getItem("globalDateFormat");
        this.getBranchList();
    },
    methods: {    
        async getWFHSummary() {
            this.isLoading = true; // ✅ Start loader

            try {
                const formData = {
                    company_id: this.storage.companyDetails.id,
                    page: this.currentPage,
                    limit: 8,
                    location: this.slectedLocation,
                };

                const response = await axios.post(BASE_URL + '/get-all-emp-wfh-request', formData);
                this.recordList = response.data.wfhRequests;
                this.pageData = response.data.pagination;
            } catch (error) {
                console.error("Error fetching WFH summary:", error);
            } finally {
                this.isLoading = false; // ✅ Stop loader
            }
        },

        async getBranchList() {
            const formData = {
                "company_id":this.storage.companyDetails.id
            };
            await axios.post(BASE_URL + '/get-emp-branch-list',formData)
            .then((response)=>{
                this.branchList =  response.data.branchDetails;
                console.log("Role LIST:: ",response.data);
            })
        },

        openPopup(id, status, reason) {
            this.isPopupOpen = true;
            this.wfhStatus = status;
            this.wfhid = id;
            this.wfhreason = reason;
        },

        closePopup() {
            this.isPopupOpen = false;
        },

        saveWFHStatus(){
            const formData = {
                "wfh_id": this.wfhid,
                "status": this.wfhStatus,
            };
            axios.post(BASE_URL + '/change-wfh-request-status', formData)
                .then((response) => {
                    this.getWFHSummary();
                    this.closePopup();
                    if(response.data.success == 'success'){
                        this.tostMessage('success', response.data.message);
                    }else{
                        this.tostMessage('error', response.data.message);
                    }                   
                })
                .catch((error) => {
                    console.error("Error updating WFH status:", error);
                });
        },

        tostMessage(status,message){
            createToast({
            // title: title,
            description: message
            },
            {
            type: status,
            timeout: 2500,
            position: 'bottom-right',
            showIcon: 'true'
            })
        },

        handlePageChange(newPage) {
            if (this.$route.query.page === newPage) return
            const query = { ...this.$route.query }
            if (newPage) query.page = newPage
            else delete query.page
            this.$router.replace({ query })
            this.currentPage = newPage;
            this.getWFHSummary();
        },

        formatDate(date) {
            if (!date) return '';
            return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
        },

    }
};
</script>